<template>
  <PageVC>
    <div class="a-container">
      <h1 class="a-page-title">Dine oplysninger</h1>
      <form ref="form" @submit="handleFormSubmit">
        <HUIFieldset class="booking__fieldset" :disabled="submitting">
          <HUILegendWithBullets class="booking__fieldset-legend">1</HUILegendWithBullets>
          <dl class="booking__summary-dl a-summary-dl">
            <dt class="a-summary-dl__dt">Hvor</dt>
            <dd class="a-summary-dl__dd">
              Halifax {{restaurant.name}}
              <br />
              <small
                class="booking__summary-dl-address"
              >{{restaurant.address}}, {{restaurant.zip_code}} {{restaurant.city}}</small>
            </dd>
            <dt class="a-summary-dl__dt">Hvornår</dt>
            <dd class="a-summary-dl__dd">{{computedTime}}</dd>
            <dt class="a-summary-dl__dt">Antal gæster</dt>
            <dd class="a-summary-dl__dd">{{guests}}</dd>
          </dl>
        </HUIFieldset>
        <HUIFieldset class="booking__fieldset" :disabled="submitting">
          <HUILegendWithBullets class="booking__fieldset-legend">2</HUILegendWithBullets>
          <HUITextInput
            class="booking__fieldset-input"
            required
            autocomplete="name"
            placeholder="Navn"
            name="name"
            v-model="name"
            @input="handleTextInputInput"
          />
          <HUITextInput
            class="booking__fieldset-input"
            required
            autocomplete="tel"
            type="tel"
            placeholder="Mobilnummer"
            name="phone"
            v-model="phone"
            @input="handleTextInputInput"
          />
          <HUITextInput
            class="booking__fieldset-input"
            required
            autocomplete="email"
            type="email"
            placeholder="Email"
            name="email"
            v-model="email"
            @input="handleTextInputInput"
          />
          <HUITextInput
            class="booking__fieldset-input"
            autocomplete="off"
            placeholder="Bemærkninger el. særlige ønsker"
            name="comment"
            v-model="comment"
            @input="handleTextInputInput"
          />

          <p style="margin-top: 20px; margin-left: 4px;">Bemærk at det er ikke muligt at garantere særlige placeringer.</p>

          <HUICheckbox class="booking__fieldset-checkbox" required v-model="gdprChecked">
            Jeg accepterer
            <a
              target="_blank"
              href="https://www.halifax.dk/gdpr"
            >privatlivsbetingelserne</a>.
          </HUICheckbox>
          <HUICheckbox
            class="booking__fieldset-checkbox"
            v-model="newsletter"
          >Jeg vil gerne modtage burger-lovin’ i form af gode tilbud, nyheder &amp; andre sjove Halifax-initiativer.</HUICheckbox>
        </HUIFieldset>

        <div class="booking__button-group a-button-group">
          <RouterButton class="booking__back" to="BACK" v-if="framed">Tilbage</RouterButton>
          <HUIButton
            class="booking__next"
            :spinner="submitting"
            :disabled="!isValid"
            type="submit"
            theme="green"
            to="BOOKING_3"
          >
            <span>Bekræft</span>
            <span>reservation</span>
          </HUIButton>
        </div>
      </form>
    </div>
  </PageVC>
</template>

<script>
import { mapState } from 'vuex'
import {
  HUITextInput,
  HUILegendWithBullets,
  HUIButton,
  HUIFieldset,
  HUICheckbox
} from '@/halifax-ui'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import flowStep from '@/mixins/flowStep'
import routes from '@/router/routes'
import { getDateString } from '@/utils/dateHelpers'

export default {
  mixins: [flowStep],
  components: {
    HUIButton,
    PageVC,
    HUITextInput,
    HUILegendWithBullets,
    RouterButton,
    HUIFieldset,
    HUICheckbox
  },
  data() {
    const { restaurant, guests, date, time } = JSON.parse(
      window.sessionStorage.getItem('booking/temp-booking') || '{}'
    )

    return {
      restaurant,
      guests,
      date,
      time,
      name: '',
      phone: '',
      email: '',
      comment: '',
      submitting: false,
      gdprChecked: false,
      newsletter: false
    }
  },
  computed: {
    ...mapState({
      framed: 'framed'
    }),
    computedTime() {
      // 2018/08/10 14:30:00.00000 -> 2018-08-10 14:30:00 for Safari
      const date = new Date(`${this.date.replace(/-/g, '/')} ${this.time}`)
      return getDateString(date, { month: 'long' })
    }
  },
  watch: {
    gdprChecked() {
      this.updateValidity()
    }
  },
  beforeRouteEnter(to, from, next) {
    const { restaurant, guests, date, time } = JSON.parse(
      window.sessionStorage.getItem('booking/temp-booking') || '{}'
    )

    if (restaurant && guests && date && time) {
      next()
    } else {
      next({
        name: routes.BOOKING
      })
    }
  },
  created() {
    this.updateValidity()
  },
  mounted() {
    this.$bus.$on('CREATE_BOOKING_FAILED', this.handleCreateBookingFailed)
  },
  beforeDestroy() {
    this.$bus.$off('CREATE_BOOKING_FAILED', this.handleCreateBookingFailed)
  },
  methods: {
    updateValidity() {
      this.__setValidity(this.name && this.phone && this.email && this.$refs.form.checkValidity())
    },
    handleTextInputInput() {
      this.updateValidity()
    },
    handleFormSubmit(event) {
      event.preventDefault()

      const { restaurant, guests, date, time, name, phone, email, comment, newsletter } = this

      this.submitting = true
      this.$emit('subview-event', {
        type: 'step2-complete',
        data: {
          restaurant,
          guests,
          date,
          time,
          name,
          phone,
          email,
          comment,
          newsletter
        }
      })
    },
    handleCreateBookingFailed() {
      this.submitting = false
    }
  }
}
</script>

<style lang="scss">
</style>
